import { render, staticRenderFns } from "./SalesListItem.vue?vue&type=template&id=a2449e94&"
import script from "./SalesListItem.vue?vue&type=script&lang=js&"
export * from "./SalesListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SalesListItem.vue"
export default component.exports